import createReducer from 'utils/createReducer';
import _ from 'lodash';

// Initial State
const INIT_STATE = {
  pageSize: 200,
  count: 0,
  data: [],
  loading: false,
  loadingMore: false,
  error: null,
  filters: {},
  selected: [],
  modalOpened: false,
};

// Actions
const FETCH_REQUEST = 'outcodes/FETCH_REQUEST';
const FETCH_CANCEL = 'outcodes/FETCH_CANCEL';
const FETCH_DONE = 'outcodes/FETCH_DONE';

const FETCH_MORE_REQUEST = 'outcodes/FETCH_MORE_REQUEST';
const FETCH_MORE_CANCEL = 'outcodes/FETCH_MORE_CANCEL';
const FETCH_MORE_DONE = 'outcodes/FETCH_MORE_DONE';

const SET_SELECTED = 'outcodes/SET_SELECTED';
const CLEAN_SELECTED = 'outcodes/CLEAN_SELECTED';
const SET_MODAL_OPENED = 'outcodes/SET_MODAL_OPENED';

const EDIT_REQUEST = 'outcodes/EDIT_REQUEST';
const EDIT_CANCEL = 'outcodes/EDIT_CANCEL';
export const EDIT_DONE = 'outcodes/EDIT_DONE';

const SET_FILTERS = 'outcodes/SET_FILTERS';

// Reducers
export default createReducer(INIT_STATE, {
  [FETCH_REQUEST](state) {
    return {
      ...state,
      loading: true,
      data: [],
      selected: [],
    };
  },
  [FETCH_MORE_REQUEST](state) {
    return {
      ...state,
      loadingMore: true,
    };
  },
  [FETCH_CANCEL](state, payload) {
    return {
      ...state,
      loading: false,
      error: payload,
    };
  },
  [FETCH_MORE_CANCEL](state, payload) {
    return {
      ...state,
      loadingMore: false,
      error: payload,
    };
  },
  [FETCH_DONE](state, payload) {
    const { count, results, next } = payload;

    return {
      ...state,
      loading: false,
      data: results,
      next,
      count,
    };
  },
  [FETCH_MORE_DONE](state, payload) {
    const { count, results, next } = payload;

    return {
      ...state,
      loadingMore: false,
      data: [...state.data, ...results],
      next,
      count,
    };
  },
  [SET_SELECTED](state, payload) {
    return {
      ...state,
      selected: _.difference(state.selected, payload).concat(_.difference(payload, state.selected)),
    };
  },
  [CLEAN_SELECTED](state) {
    return {
      ...state,
      selected: [],
    };
  },
  [SET_MODAL_OPENED](state, payload) {
    return {
      ...state,
      modalOpened: payload,
    };
  },
  [SET_FILTERS](state, payload) {
    return {
      ...state,
      filters: payload,
    };
  },
  [EDIT_REQUEST](state) {
    return {
      ...state,
      editLoading: true,
    };
  },
  [EDIT_DONE](state) {
    return {
      ...state,
      editLoading: false,
    };
  },
});

// Action creators
export const request = () => ({
  type: FETCH_REQUEST,
});

export const cancel = (error) => ({
  type: FETCH_CANCEL,
  payload: error,
});

export const done = (outcodes) => ({
  type: FETCH_DONE,
  payload: outcodes,
});

export const requestMore = () => ({
  type: FETCH_MORE_REQUEST,
});

export const cancelMore = (error) => ({
  type: FETCH_MORE_CANCEL,
  payload: error,
});

export const doneMore = (outcodes) => ({
  type: FETCH_MORE_DONE,
  payload: outcodes,
});

export const setSelected = (outcodes) => ({
  type: SET_SELECTED,
  payload: outcodes,
});

export const cleanSelected = (outcodes) => ({
  type: CLEAN_SELECTED,
});

export const setOpened = (opened) => ({
  type: SET_MODAL_OPENED,
  payload: opened,
});

export const editRequest = () => ({
  type: EDIT_REQUEST,
});

export const editCancel = (error) => ({
  type: EDIT_CANCEL,
  payload: error,
});

export const editDone = (outcode) => ({
  type: EDIT_DONE,
  payload: outcode,
});

export const setFilters = (filters) => ({
  type: SET_FILTERS,
  payload: filters,
});
